import React from 'react';
import PropTypes from 'prop-types';

import ImageWithFallback from '../../../global/components/helpers/ImageWithFallback';

const ContentModuleCard2 = ({
  contentModule
  , handleOpenModule
  , index
  , displayModuleDescriptions
}) => {

  const { title, summary, trailerPosterPath } = contentModule;

  const posterPath = trailerPosterPath ?
    trailerPosterPath.includes('http') ?
      trailerPosterPath : `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/visits/${trailerPosterPath}`
    : '/img/module_placeholder.png';

  return (
    <div className={`group cursor-pointer mx-12 md:px-0 md:bg-gray-100 hover:bg-pf-steel-100 hover:opacity-80 rounded`} onClick={handleOpenModule}>
      <div className={`flex flex-wrap ${index % 2 == 0 ? 'flex-row' : 'flex-row-reverse'}`}>
        <div className="relative w-full md:w-1/2">
          <ImageWithFallback
            src={posterPath}
            alt={title}
            fallback={'/img/module_placeholder.png'}
            className="w-full h-48 md:h-64 object-cover rounded"
          />
          <div className="invisible group-hover:visible flex absolute top-0 bottom-0 w-full justify-center">
            <i className="fa-regular fa-circle-play text-[#7F9BB4] fa-5x my-auto "></i>
          </div>
          {posterPath === '/img/module_placeholder.png' && (
            <div className="flex absolute top-36 md:top-52 w-full items-center justify-center">
              <p className="text-[8px] text-pf-neutrone-500">powered by</p>
              <img src={'/img/pf-logo-new2.png'} className="h-4 w-auto" />
            </div>
          )}
        </div>
        <div className="w-full md:w-1/2 my-4 md:px-8 flex flex-col justify-center">
          <h3 className="text-pf-black-700 text-2xl font-semibold m-0">{title}</h3>
          {summary && displayModuleDescriptions && (<p className="text-pf-black-700 text-base md:mt-2">{summary}</p>)}
        </div>
      </div>
    </div>
  )
}

ContentModuleCard2.propTypes = {
  contentModule: PropTypes.object.isRequired
  , handleOpenModule: PropTypes.func.isRequired
  , displayModuleDescriptions: PropTypes.bool
}

export default ContentModuleCard2;


